module.exports = __webpack_public_path__ + "img/EggCracked.8a549db9.png";